export const logContexts = ['all', 'auth', 'api', 'canvas', 'saga', 'realtime'];
